import { MultiTenancyProfile } from './multi-tenancy-profile.enum';
import { StringUtils } from '../common';
import { HttpEndpoint, HttpRequest } from '../../../core';

export class MultiTenancyEndpoint extends HttpEndpoint {
  private _prefix = '';
  private _activeProfile!: MultiTenancyProfile;

  constructor(
    contextPath: string,
    profile: MultiTenancyProfile = MultiTenancyProfile.DE
  ) {
    super();
    this._prefix = contextPath;
    this.setActive(profile);
  }

  /**
   * Set active profile and create a new root path.
   *
   */
  public setActive(profile: MultiTenancyProfile) {
    if (profile === undefined || profile === null) {
      return;
    }

    if (!StringUtils.isEmpty(profile.toString())) {
      this._rootPath = `${this._prefix}/${profile.toString()}`;
    } else {
      this._rootPath = this._prefix;
    }

    this._activeProfile = profile;
  }

  /**
   * Get active profile
   */
  get activeProfile(): MultiTenancyProfile {
    return this._activeProfile;
  }

  /**
   * Hacking for Partners. Partners resource is common for all tenancies.
   *
   */
  override getRoot(request: HttpRequest): string {
    return super.getRoot(request);
  }
}
